export default __webpack_public_path__ + "static/media/rocketBlack.e8602d45.svg";